import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import assignCostPerTripImg from 'assets/images/assign-cost-per-trip.svg'
import assignCostPerKmImg from 'assets/images/assign-cost-per-km.svg'
import FormLayout from 'components/v2/FormLayout'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { NavLink } from 'react-router-dom'
import { device } from 'utils/style'

const Wrapper = styled.div`
  padding: 148px 0;
`

const CardContainer = styled.div`
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 0px 30px 0px rgba(102, 119, 150, 0.15);
  margin: 0 auto;
  max-width: 972px;
  width: 100%;
`

const CardContent = styled.div`
  padding: 56px 78px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const CardTitle = styled.h2`
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: #28265d;
  text-align: center;
`

const SelectAssignCostGrid = styled.div`
  display: grid;
  gap: 20px;

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
  }
`

const AssignCostOption = styled.div`
  border-radius: 8px;
  border: 1px solid #eae9e9;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 30px;
  text-decoration: none;
  cursor: pointer;
`

const AssignCostOptionTitleWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

const AssignCostOptionIcon = styled.img`
  height: 48px;
  width: 48px;
`

const AssignCostOptionTitle = styled.h3`
  color: #1e0e62;
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  line-height: 145%;
`

const AssignCostOptionDescription = styled.p`
  margin: 0;
  color: #28265d;
  font-size: 16px;
  font-weight: 400;
  line-height: 162.5%;
`

const SelectPartnerCostFormView = (): ReactElement => {
  return (
    <FormLayout.Container>
      <Wrapper>
        <CardContainer>
          <CardContent>
            <CardTitle>
              <FormattedMessage id="partnerCost.selectForm.title" defaultMessage="Assign Cost" />
            </CardTitle>
            <SelectAssignCostGrid>
              <AssignCostOption as={NavLink} to="/partner-cost/new">
                <AssignCostOptionTitleWrapper>
                  <AssignCostOptionIcon src={assignCostPerTripImg} />
                  <AssignCostOptionTitle>
                    <FormattedMessage id="partnerCost.selectForm.perTrip" defaultMessage="Assign Cost per Trip" />
                  </AssignCostOptionTitle>
                </AssignCostOptionTitleWrapper>
                <AssignCostOptionDescription>
                  <FormattedMessage
                    id="partnerCost.selectForm.perTripDescription"
                    defaultMessage="Calculate the costs associated with the use of a vehicle for each partner."
                  />
                </AssignCostOptionDescription>
              </AssignCostOption>
              <AssignCostOption as={NavLink} to="/partner-cost/assign-cost-per-km">
                <AssignCostOptionTitleWrapper>
                  <AssignCostOptionIcon src={assignCostPerKmImg} />
                  <AssignCostOptionTitle>
                    <FormattedMessage id="partnerCost.selectForm.perKm" defaultMessage="Assign Cost per Km" />
                  </AssignCostOptionTitle>
                </AssignCostOptionTitleWrapper>
                <AssignCostOptionDescription>
                  <FormattedMessage
                    id="partnerCost.selectForm.perKmDescription"
                    defaultMessage="Calculate the costs associated with the use of a vehicle based on the distance traveled."
                  />
                </AssignCostOptionDescription>
              </AssignCostOption>
            </SelectAssignCostGrid>
          </CardContent>
        </CardContainer>
      </Wrapper>
    </FormLayout.Container>
  )
}

export default withLastUrl(SelectPartnerCostFormView)
